import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

const ONE_REM_IN_PX = 16

export const isDev = process.env.NODE_ENV === 'development'

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}

export const round = (num: number) =>
  num
    .toFixed(7)
    .replace(/(\.[0-9]+?)0+$/, '$1')
    .replace(/\.0$/, '')

export const rem = (px: number) => `${round(px / ONE_REM_IN_PX)}rem`

export const em = (px: number, base: number) => `${round(px / base)}em`

export const hexToRgb = (hex: string) => {
  hex = hex.replace('#', '')
  hex = hex.length === 3 ? hex.replace(/./g, '$&$&') : hex
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  return `${r} ${g} ${b}`
}
